<template>
  <table class="debug-values">
    <thead>
    <tr>
      <template v-for="(v, i) in compHeader">
        <th class="text-right">
          {{ v }}
        </th>
      </template>
    </tr>
    </thead>
    <tbody>
    <tr>
      <template v-for="(v, i) in compColumns">
        <td class="text-right">
          {{ v }}
        </td>
      </template>
    </tr>
    </tbody>
  </table>
</template>

<script>
import UtilsData from "@/utilities/UtilsData";

export default {
  name:       "objectToTable",
  props:      {
    propObject: {
      type:    Object | String,
      default: {}
    }
  },
  components: {},
  data() {
    return {}
  },
  computed: {
    compData:    function () {
      return UtilsData.tryToObject(this.propObject);
    },
    compHeader:  function () {
      return Object.keys(this.compData);
    },
    compColumns: function () {
      return Object.values(this.compData);
    }
  },
  methods:  {}
};
</script>

<style>
.debug-values {
  background-color: antiquewhite
}
table.debug-values th, table.debug-values td {
  padding: 5px 15px !important;
  text-align: left !important;
}
</style>
